<template>
  <div v-if="serviceInfo">
    <div style="display: flex">
      <div class="sku-left">
        <van-image
          fit="cover"
          :width="imageSize + 'px'"
          :height="imageSize + 'px'"
          error-icon=""
          loading-icon=""
          :src="getServiceImageUrl()"
        />
      </div>
      <div class="sku-header">
        <span style="font-size: 16px; color: #333333; font-weight: 500">
          {{ serviceInfo.name }}
        </span>
        <div style="color: #919191; font-size: 14px">
          <span>{{ serviceInfo.desc || "无说明" }}</span>
        </div>
        <!-- <div style="color: #919191">
          <span style="margin-right: 5px">
            7日消耗
            <span style="color: #333333">
              {{ serviceInfo.consume7dayCount || 0 }}
            </span>
            <span>次</span>
          </span>
          <span style="margin-right: 5px">
            30日消耗
            <span style="color: #333333">
              {{ serviceInfo.consume30dayCount || 0 }}
            </span>
            <span>次</span>
          </span>
          <span style="margin-right: 5px">
            150日消耗
            <span style="color: #333333">
              {{ serviceInfo.consume150dayCount || 0 }}
            </span>
            <span>次</span>
          </span>
        </div> -->
        <slot name="info-append" />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.sku-left {
  font-size: 12px;
  margin-right: 12px;
}

.sku-header {
  font-size: 14px;
  line-height: 18px;
}
</style>

<script>
import { Image as vanImage } from "vant";
import "vant/lib/image/style";

export default {
  components: {
    vanImage,
  },
  props: {
    imageSize: {
      type: Number,
      default: 60,
    },
    serviceInfo: {
      type: Object,
    },
  },
  methods: {
    getServiceImageUrl() {
      return (
        `${this.serviceInfo && this.serviceInfo.image}`.split("|")[0] ||
        this.getConfig("defaultImageUrl")
      );
    },
  },
};
</script>
